module.exports = __webpack_public_path__ + "img/mp-img-13.2fa640b4.jpg";